import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import { GetReleaseNotesUrl, GetNewsFeedUrl, AlertMessagesURL, GetAlertMessageTemplatesURL, UpdateAlertsURL, CreateReleaseNotesUrl, UpdateReleaseNotesUrl } from '../constants';
import _ from 'lodash';
export function GetNewsFeed(api) {
  return function (symbols, updatedSince, channels) {
    var symbs = _.isArray(symbols) ? symbols : [symbols];
    return api.get(GetNewsFeedUrl, {
      symbols: symbs.join(','),
      updatedSince: updatedSince,
      channels: channels
    });
  };
}
export var create = function create(api) {
  return function (releaseNote) {
    return api.authenticated().post(CreateReleaseNotesUrl, releaseNote, {
      headers: {
        Accept: 'application/json'
      }
    });
  };
};
export var info = function info(api) {
  return {
    get: function get(request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var page, pageSize, searchRequest;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = request.page ? request.page : 0;
                pageSize = request.pageSize ? request.pageSize : 5;
                searchRequest = Object.assign({}, request, {
                  page: page,
                  pageSize: pageSize
                });
                _context.next = 5;
                return api.get(GetReleaseNotesUrl, searchRequest);

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    createAlert: function createAlert(alert) {
      return api.authenticated().post(AlertMessagesURL, alert);
    },
    getActiveAlerts: function getActiveAlerts(request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return api.get(AlertMessagesURL, request);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    },
    getAlertTemplates: function getAlertTemplates(request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return api.get(GetAlertMessageTemplatesURL, request);

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    },
    updateAlert: function updateAlert(request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return api.authenticated().put(UpdateAlertsURL(request.id, request.active), request);

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    },
    news: GetNewsFeed(api),
    createReleaseNote: create(api),
    updateReleaseNote: function updateReleaseNote(releaseNote) {
      return api.authenticated().put(UpdateReleaseNotesUrl(releaseNote.id), {
        releaseDate: releaseNote.releaseDate,
        summary: releaseNote.summary,
        restrictedToUserLevel: releaseNote.restrictedToUserLevel,
        type: releaseNote.type
      });
    }
  };
};